// SIDE BAR MENU
export const ADD_SIDE_BAR_MENU = 'ADD_SIDE_BAR_MENU';
export const EMPTY_SIDE_BAR_MENU = 'EMPTY_SIDE_BAR_MENU';
